import { compare, major, prerelease } from "semver";

// TODO: move me out of mannequin
export class VersionTag {
  available: string[];
  main: Record<string, string>;

  constructor(available: string[] = []) {
    this.available = available.sort(compareVersionStrings);
    this.main = {};
    this.updateMain();
  }

  addVersion(version: string): boolean {
    if (this.hasVersion(version)) {
      return false;
    }

    this.available.push(version);
    this.available = this.available.sort(compareVersionStrings);
    this.updateMain();

    return true;
  }

  hasVersion(version: string): boolean {
    return this.available.includes(version);
  }

  latestVersion(includePrerelease = true): string | undefined {
    if (this.available.length === 0) {
      return undefined;
    }

    const sorted = this.available
      .sort(compareVersionStrings)
      .filter(v => includePrerelease || !prerelease(v));

    return sorted[sorted.length - 1];
  }

  static fromJSON(json: any): VersionTag | undefined {
    if (!json || !json.available || !Array.isArray(json.available)) {
      return undefined;
    }

    return new VersionTag(json.available);
  }

  /**
   * Update main entry for major version with highest version running / run
   * (don't include prerelease)
   */
  private updateMain() {
    for (const version of this.available) {
      const mv = majorVersion(version);
      if (this.main[mv] !== undefined) {
        if (compareVersionStrings(version, this.main[mv]) > 0 && prerelease(version) === null) {
          this.main[mv] = version;
        }
      } else {
        this.main[mv] = version;
      }
    }
  }
}

export function majorVersion(vStr: string): string {
  return major(vStr).toString();
}

export function compareVersionStrings(vA: string, vB: string): number {
  return compare(vA, vB);
}

export function versionStringHasLegacyJsonChunks(vStr: string): boolean {
  return compareVersionStrings(vStr, "0.6.0") <= 0;
}
